import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

import 'bootstrap-icons/font/bootstrap-icons.css'

const app = createApp(App)
app.use(router).use(store).mount('#app')
